module.exports = __webpack_public_path__ + "e57f47c48f7d90a693b419a9c79ab45f.svg";